module.exports = __webpack_public_path__ + "static/media/download.d965017d.gif";